const CompanyName = () => {
  return (
    <span className="companyName">
      <span className="companyColor">App</span>Thing
    </span>
  );
};

export default CompanyName;
